import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  fanVoices: [],
  fetchLoading: false,
  fetchFanChoiceResults: false,
  singleFanVoice: null,
  fanChoiceResults: [],
};

const slice = createSlice({
  name: "fanvoice",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateFanVoiceSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanVoices = state.fanVoices.map((fanVoice) => {
        if (fanVoice.id === action.payload.id) {
          return action.payload;
        }
        return fanVoice;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getFanVoiceSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanVoices = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleFVSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleFanVoice = action.payload;
    },

    // GET PRODUCTS
    createFVSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanVoices = [...state.fanVoices, action.payload];
    },

    // DELETE EVENT
    deleteFVSuccess(state, action) {
      const fvId = action.payload;
      state.fanVoices = state.fanVoices.filter((game) => game.id !== fvId);
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // DELETE EVENT
    fanChoiceResultsSuccess(state, action) {
      state.fanChoiceResults = action.payload;
      state.fetchFanChoiceResults = false;
    },

    startFetchFanChoiceResults(state) {
      state.fetchFanChoiceResults = true;
    },
  },
});

export default slice.reducer;

export function getFanVoices({ season_id, game_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("fan-activities", {
        params: {
          season_id,
          game_id,
        },
      });
      dispatch(slice.actions.getFanVoiceSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleFanVoice({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`fan-activities/${id}`);
      dispatch(slice.actions.getSingleFVSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFVOfActivity({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchFanChoiceResults());
    try {
      const response = await axios.get(`voices`, {
        params: {
          fan_activity_id: id,
        },
      });

      dispatch(slice.actions.fanChoiceResultsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createFanVoices({ data, enqueueSnackbar, onClose }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("fan-activities", data);
      dispatch(slice.actions.createFVSuccess(response.data.data));
      enqueueSnackbar("Fan Voice is added successfully");
      onClose && onClose();
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function udpateFanVoice({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`fan-activities/${id}`, data);
      dispatch(slice.actions.updateFanVoiceSuccess(response.data.data));
      enqueueSnackbar("Fan Voice is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteFanVoice({ id, enqueueSnackbar, setOpenConfirm }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`fan-activities/${id}`);
      dispatch(slice.actions.deleteFVSuccess(id));
      enqueueSnackbar("Fan Voice is deleted successfully");
      setOpenConfirm(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
